import api from "./http";
import { API_ENDPOINTS } from "./endpoints";

export async function createInvoice({ planId, billingCycle = "monthly", dueDays }) {
  const res = await api.post(API_ENDPOINTS.BILLING_INVOICES, {
    planId,
    billingCycle,
    dueDays,
  });
  return res;
}

export async function reconcileBilling(payload = {}) {
  // if your backend expects empty body, this is fine
  const res = await api.post(API_ENDPOINTS.BILLING_RECONCILE, payload);
  return res;
}
